import React from 'react';
import PropTypes from 'prop-types';

import { AccountBoxRounded, BarChartRounded, BusinessRounded } from '@material-ui/icons';

const pagesAuthenticated = (t, i18n, permissions, unit, reports) => {
    let protectedRoutes = {};

    const hasUnitPermission = permissions.find((perm) => perm.name === 'UNIT');

    if (hasUnitPermission) {
        protectedRoutes = { ...protectedRoutes, ...protectedEntries(t) };
    }

    const hasAdminPermission = permissions.find((perm) => perm.name === 'ADMIN');

    if (hasAdminPermission) {
        protectedRoutes = { ...protectedRoutes, ...adminEntries(t) };
    }

    const perms = [];

    if (unit) {
        let unitDirectories = [];

        if (reports?.length) {
            const categorizedReports = reports.reduce((acc, report) => {
                const category = report.defaultCategory;
                if (!acc[category]) {
                    acc[category] = [];
                }

                acc[category].push(report);

                return acc;
            }, {});

            const directories = Object.entries(categorizedReports)
                .sort((a, b) => t(a[0]).localeCompare(t(b[0])))
                .map(([category, reports]) => {
                    const subDirectories = reports
                        .sort((reportA, reportB) =>
                            (reportA.name[i18n.language] || reportA.name['en-US']).localeCompare(
                                reportB.name[i18n.language] || reportB.name['en-US']
                            )
                        )
                        .map((report) => {
                            return {
                                title: report.name[i18n.language] || report.name['en-US'],
                                href: `/unit/${unit.id}/pbreport/${report.id}`
                            };
                        });

                    return {
                        title: t(category),
                        href: false,
                        subDirectories
                    };
                });

            unitDirectories = [...directories];
        }

        if (unit.externalReports?.length) {
            unitDirectories.push({
                title: t('Other reports'),
                href: false,
                subDirectories: unit.externalReports.map((report, i) => ({
                    title: report.name,
                    href: `/report/${i}`
                }))
            });
        }

        protectedRoutes = {
            DISCOVERY: {
                title: t('Analytics'),
                icon: <BarChartRounded />,
                permission: ['DASHBOARD'],
                directories: unitDirectories
            },
            ...protectedRoutes
        };
    }

    Object.values(protectedRoutes).forEach((value) => {
        perms.push(value);
    });

    return perms;
};

const SubMenuItem = ({ title }) => (
    <span
        style={{
            fontSize: 12,
            display: 'flex',
            alignItems: 'center',
            fontWeight: 500
        }}
    >
        {title}
    </span>
);

SubMenuItem.propTypes = {
    title: PropTypes.string
};

const protectedEntries = (t) => ({
    ACCOUNT: {
        title: t('Account'),
        icon: <BusinessRounded />,
        permission: ['UNIT'],
        directories: [
            {
                title: t('Settings'),
                href: '/unit/profile'
            },
            {
                title: t('Users'),
                href: '/unit/users'
            }
        ]
    }
});

const adminEntries = (t) => ({
    ADMIN: {
        title: 'Admin',
        icon: <AccountBoxRounded />,
        permission: ['ADMIN'],
        directories: [
            {
                title: t('Report administration'),
                href: '/admin/report'
            },
            {
                title: t('Unit administration'),
                href: '/admin/unit'
            }
        ]
    }
});

export default pagesAuthenticated;
